import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Slider from 'react-slick';

var Carousel = function Carousel(props) {
  var children = props.children,
      settings = props.settings,
      type = props.type;
  var carouselType = typeof type !== 'undefined' ? "cb-carousel cb-carousel--".concat(type) : 'cb-carousel';
  var options = Object.assign({
    lazyLoad: true
  }, settings);
  var isSolid = children.some(function (child) {
    var _child$props, _child$props$layout;

    return ((_child$props = child.props) === null || _child$props === void 0 ? void 0 : (_child$props$layout = _child$props.layout) === null || _child$props$layout === void 0 ? void 0 : _child$props$layout.background) === 'solid';
  });
  return /*#__PURE__*/React.createElement(Slider, _extends({}, props, options, {
    className: "".concat(carouselType, " ").concat(isSolid ? 'cb-carousel--solid' : '')
  }), children);
}; // For available props (settings) go here: https://react-slick.neostack.com/docs/api/


Carousel.defaultProps = {
  settings: {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true,
        touchMove: true
      }
    }]
  }
};
export default Carousel;